 <header class="geolocation-request__header">
  <ci-icon 
    class="geolocation-request__icon"
    type="svg"
    name="navigation" 
    scale="3x"
  ></ci-icon>
  
  <h1 
    id="geolocation-title"
    class="geolocation-request__title ci-heading-h3-s-bold"
  >
    ¿{{ 'Quieres seguir tu ruta en tiempo real' | translate }}?
  </h1>
</header>